<template>
    <div class="sideBar">
        <!-- @click="toKf" -->
        <div class="onlineAsk" @click="toKf" v-if="false">
            <div class="onlineAskInfo">
                <img src="@/assets/image/common/onlineAskIco.png" alt="" />
                <div class="word">在线咨询</div>
                <i class="el-icon-arrow-left"></i>
            </div>
            <!-- 效果背景板 -->
            <!-- <div class="onlineAskBroad"></div> -->
        </div>
        <div class="weixinAsk" v-if="false">
            <div class="weixinAskInfo">
                <img src="@/assets/image/common/weixinAskIco.png" alt="" />
                <div class="word">微信咨询</div>
                <i class="el-icon-arrow-left"></i>
            </div>
            <!-- 效果背景板 -->
            <div class="weixinAskBroad"></div>
            <div class="showCodeBox">
                <img src="@/assets/image/common/eweim1.png" alt="" />
                <div class="codePic">
                    <img src="../../assets/image/common/qrcodeWx.png" alt="" />
                </div>
            </div>
        </div>
        <div class="onlineAsk" @mouseleave="mouseleaveCode" @mousemove="openCode">
            <div class="onlineAskInfo" @click="openCode">
                <img src="@/assets/image/common/onlineAskIco.png" alt="" />
                <div class="word">联系方式</div>
                <i class="el-icon-arrow-left"></i>
            </div>
            <!-- 效果背景板 -->
            <div class="showCodeBox" ref="showCodeBox" v-show="false">
                <!-- <img src="@/assets/image/common/eweim1.png" alt="" /> -->
                <div class="codePic">
                    <img src="../../assets/image/common/qrcodePic.png" alt="" />
                </div>
            </div>
        </div>
        <!-- <live800-js-597710 /> -->
    </div>
</template>

<script>
export default {
    components: {
        'live800-js-597711': {
            render(createElement) {
                return createElement('script', {
                    attrs: {
                        type: 'text/javascript',
                        src: 'https://chat56.live800.com/live800/chatClient/floatButton.js?jid=9257521571&companyID=1676669&configID=597711&codeType=custom&ss=1&delayload=1',
                    },
                });
            },
        },
        'live800-js-597710': {
            render(createElement) {
                return createElement('script', {
                    attrs: {
                        type: 'text/javascript',
                        src: 'https://chat56.live800.com/live800/chatClient/monitor.js?jid=9257521571&companyID=1676669&configID=597710&codeType=custom&ss=1&delayload=1',
                    },
                });
            },
        },
    },
    data() {
        return {
            keUrl: 'https://chat56.live800.com/live800/chatClient/chatbox1676669.jspc?companyID=1676669&configID=597711&jid=9257521571&s=1',
        };
    },
    methods: {
        mouseleaveCode() {
            this.$refs.showCodeBox.style.opacity = '0';
            this.$refs.showCodeBox.style.display = 'none';
        },
        //执行弹出框
        openCode() {
            if (this.$refs.showCodeBox) {
                this.$refs.showCodeBox.style.display = 'block';
                this.$refs.showCodeBox.style.opacity = '1'; // 设置透明度为 0.5
            }
        },
        toKf() {
            window.open(this.keUrl, '_blank', 'top=300,left=300,width=800,height=500,menubar=no,toolbar=no,status=no,scrollbars=yes');
        },
    },
};
</script>

<style lang="scss" scoped>
.sideBar {
    width: 50px;
    position: fixed;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 100;

    .onlineAsk,
    .weixinAsk {
        width: 100%;
        height: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 16px 0px 0px 16px;
        position: relative;

        img {
            width: 24px;
        }

        .word {
            width: 16px;
            color: #fff;
            margin-top: 15px;
            margin-bottom: 30px;
        }

        i {
            color: #fff;
        }

        .weixinAskInfo,
        .onlineAskInfo {
            position: absolute;
            width: 100%;
            height: 250px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            // background: #1472ff;
            border-radius: 16px 0px 0px 16px;
            z-index: 2;
            cursor: pointer;
            &:hover {
                background: #4e94ff;
            }
        }

        .weixinAskBroad,
        .onlineAskBroad {
            position: absolute;
            width: 100%;
            height: 250px;
            background: #7e8da2;
            border-radius: 16px 0px 0px 16px;
            z-index: 1;
        }

        .weixinAskInfo,
        .weixinAskBroad {
            background-color: #ffae32;
        }

        .onlineAskInfo,
        .onlineAskBroad {
            // background: #1472ff;
        }

        .showCodeBox {
            position: absolute;
            right: 230px;
            transition: all 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
            z-index: 100;
            opacity: 0;
            img {
                width: 120px;
                // transform: rotate(-90deg);
            }

            .codePic {
                width: 160px;
                position: absolute;
                top: 50%;
                left: 10px;
                transform: translateY(-50%);
                // background-color: #232323;
                padding-right: 10px;

                img {
                    width: 100%;
                }
            }
        }
    }

    .onlineAsk {
        background: #1472ff;
        &:hover {
            // background: #4e94ff;
        }
        // &:hover .onlineAskBroad {
        //     width: 65px;
        //     transform: translateX(-15px);
        // }
        // &:hover .showCodeBox {
        //     right: 230px;
        // }
    }

    .weixinAsk {
        background: #232323;

        &:hover .weixinAskBroad {
            width: 65px;
            transform: translateX(-15px);
        }

        &:hover .showCodeBox {
            right: 79px;
        }
    }
}
</style>
